const map = {
	"./BuddhaAkshay/images/Finance_app.svg": [
		75071,
		[
			71
		]
	],
	"./JanBhavishya/images/Finance_app.svg": [
		99902,
		[
			902
		]
	],
	"./Suvarna/images/Finance_app.svg": [
		20956,
		[
			956
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 80403;
module.exports = webpackAsyncContext;